import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
export const IconButton = ({ icon, name }) => {
  return (
    <button className="px-4 py-2 flex justify-center items-center group hover:bg-gray-600">
      <span className="text-xl text-gray-400 mr-2 group-hover:text-gray-300">
        {icon}
      </span>{" "}
      <span className="text-sm md:text-base text-gray-400 font-medium group-hover:text-gray-300">
        {name}
      </span>
    </button>
  );
};

export const Dropdown = () => {
  return (
    <select className="bg-transparent text-gray-400 font-medium">
      {OptionList?.map((option, index) => (
        <Option
          key={index}
          value={option?.value}
          className="bg-gray-700 text-gray-400 px-4 py-2 hover:bg-gray-600 hover:text-gray-300 "
        >
          {option?.label}
        </Option>
      ))}
    </select>
  );
};

const Option = styled.option`
  &:hover {
    background-color: #f5f5f5 !important;
  }
`;

const OptionList = [
  { value: 1, label: "All comments" },
  { value: 2, label: "Top comments" },
  { value: 3, label: "Most relevent" },
];
